import { createStyles, makeStyles, Theme, Box, Typography, LinearProgress } from '@material-ui/core';
import React from 'react'

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    fontFamily: 'Roboto',
    '& .text': {
      margin: '16px 0',
    },
  },
  progressBar: {
    borderRadius: '50px',
    overflow: 'hidden',
    '& .background': {
      backgroundColor: theme.palette.common.white,
    },
    '& .percent': {
      backgroundColor: theme.palette.primary.main,
    },
  }
})
);

interface OwnProps {
  readonly percentage: string;
  readonly contestGen?: boolean;
}

type Props = OwnProps;
const ProgressBar = (props: Props) => {
  const {percentage} = props;
  const classes = useStyles();
  const percentInt = parseInt(percentage);
  const getLoadingText = () => {
    let text = ''
    if (percentInt < 30) {
      text =  "Simulating Slate";
    } else if (percentInt >= 30 && percentInt < 50) {
      text =  props.contestGen ? "Building Lineups" : "Ranking Lineups";
    } else if (percentInt >= 50 && percentInt < 70) {
      text = props.contestGen ? "Building Lineups" : "Assigning Payouts";
    } else if (percentInt >= 70) {
      text = props.contestGen ? "Ranking Lineups" : "Compiling Results";
    }
    for (var i = 0; i < (Math.round(percentInt/3) % 3 + 1); i++) {
      text += ".";
    }
    return text;
  }
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%" height="100%" className={classes.root}>
      <Box width="400px">
        <img
          src={`${process.env.PUBLIC_URL}/images/Loadinganimation.gif`}
          alt=""
          style={{ width: '100%', height: '100%'}}
        />
      </Box>
      <Typography variant='h5' className='text'>{getLoadingText()}</Typography>

      <Box width="400px" height="15px" position="relative" className={classes.progressBar}>
        <LinearProgress style={{height: 50}} color='primary' value={percentInt} variant='determinate'/>
        {/* <Box width="100%" height="100%" className='background' position="absolute" />
        <Box width={parseInt(percentage, 10) + '%'} height="100%" className='percent'position="absolute" /> */}
      </Box>
    </Box>
  )
}

export default ProgressBar